import Cookies from "universal-cookie";
import { getQueryParams } from "../helpers/index.js";

const useCookies = () => {
  const { q, co } = getQueryParams();

  const keySuffix = `${q ?? ""}${co ?? ""}`;
  const cookies = new Cookies(null, { path: "/" });

  const setCookie = (name = "", value = " ") =>
    cookies.set(`${name}${keySuffix}`, value);

  const getCookie = (name = "") => cookies.get(`${name}${keySuffix}`);

  const deleteCookie = (name = "") => cookies.remove(`${name}${keySuffix}`);

  return {
    setCookie,
    getCookie,
    deleteCookie,
  };
};

export default useCookies;
